import { render, staticRenderFns } from "./orderpays.vue?vue&type=template&id=c82974a0&scoped=true"
import script from "./orderpays.vue?vue&type=script&lang=ts"
export * from "./orderpays.vue?vue&type=script&lang=ts"
import style0 from "./orderpays.vue?vue&type=style&index=0&id=c82974a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c82974a0",
  null
  
)

export default component.exports